/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup targets evergreen browsers (see .browserslistrc): the last 2 versions of
 * major browsers plus Firefox ESR. No IE11/legacy ES2015 polyfills are needed for that target.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/** *************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';
// Included with Angular CLI.
// `Window` no es estructuralmente compatible con el `Global` de @types/node (le faltan
// Buffer/GLOBAL/root/gc) — no hay un cast tipado real posible para este polyfill clásico.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).global = window;
